module.exports = __webpack_public_path__ + "static/media/e25fc5cb26785071c5c06518edb7d470.d2fd4b4d.jpg";